import { Component, OnInit, ViewChild, QueryList, ChangeDetectorRef, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaterialModule } from '../../material.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EmployeeService } from 'src/app/_services/employee.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { EmployeeAddComponent } from '../employee-add/employee-add.component';
import { Employee } from 'src/app/_model/Employee';
import { EmployeeDeleteComponent } from '../employee-delete/employee-delete.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { User } from 'src/app/_model/user';
import {UtilsService} from '../../_services/utils.service';
import {environment} from '../../../environments/environment';
import {LookupService} from '../../_services/lookup.service';
import {faFileExcel} from '@fortawesome/free-solid-svg-icons';
import { animate, state, style, transition, trigger } from '@angular/animations';
import {BaseComponent} from '../../common/base-component';
import {EmployeeSearchRequest} from '../../_model/request/EmployeeSearchRequest';
import {Lookup} from '../../_model/Lookup';
import {EmployeeReportRequest} from '../../_model/request/EmployeeReportRequest';
import {ReportService} from '../../_services/report.service';
import {AppConstants} from '../../_utils/constants';
import { PhonePipe } from 'src/app/_pipe/phonepipe';

/**
 * @title Table with expandable rows
 */
@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTabsModule,
    MatSelectModule,
    MatIconModule,
    MatCheckboxModule,
    MatTooltipModule,
    MaterialModule,
    MatDatepickerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    FontAwesomeModule,
    PhonePipe
  ]
})
export class EmployeeListComponent extends BaseComponent implements OnInit {

  @ViewChild('employeePaginator', {static: false}) paginator: MatPaginator;
  @ViewChild(MatTable, {static: true}) employeeListTable: MatTable<any>;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;

  displayedColumns: string[] = ['profilePhoto', 'name', 'tel', 'email', 'departmentname', 'jobTitlename', 'actions' ];
  innerDisplayedColumns = ['absenceTypeDesc', 'startDate', 'deservedAmount', 'transferAmount', 'totalUsedAbsenceAmount', 'remainingAmount'];
  expandedElement: any | null;

  dataSource: MatTableDataSource<any>;
  employeeList: any = [];
  selectedEmployee: Employee;
  currentUser: User;

  tableData: any = [];g
  fileUploadRoot = environment.fileUploadPath;
  employeeTitleList: any[] = [{description: 'Hepsi'}];
  selectedTitle: Lookup = this.employeeTitleList[0];
  departmentList: any[] = [{description: 'Hepsi'}];
  selectedDepartment: Lookup = this.departmentList[0];
  genderList: any[] = [{description: 'Hepsi'}] ;
  selectedGender: Lookup = this.genderList[0];
  startDateFilterValue1: any = new FormControl();
  endDateFilterValue1: any = new FormControl();
  activeFilterValue = true;
  isNewFilterValue = false;
  allEmployeeData: any[];
  pageEvent: PageEvent;
  size = 10;
  pageNumber = 0;
  paginatorIntl = new MatPaginatorIntl();
  employeeSearchRequest: EmployeeSearchRequest = new EmployeeSearchRequest(this.pageNumber, this.size, null, null);
  employeeReportRequest: EmployeeReportRequest = new EmployeeReportRequest();

  // fontawesome icon
  fileExcelIcon = faFileExcel;

  // filter values
  filterValue = null;
  filterName = '';
  filterSurname = '';

  constructor(private employeeService: EmployeeService,
              private toastr:          ToastrService,
              private authService:     AuthenticationService,
              public  dialog:          MatDialog,
              public  utilsService:    UtilsService,
              public  lookupService:   LookupService,
              private cd:              ChangeDetectorRef,
              private reportService:   ReportService) {
      super();
      this.currentUser = this.authService.currentUserValue;
      this.paginatorIntl.itemsPerPageLabel = 'Satır sayısı';
      this.paginatorIntl.getRangeLabel = function (page, pageSize, length) {
        if (length === 0 || pageSize === 0) {
          return 'Kayıt bulunamadı' ;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
          Math.min(startIndex + pageSize, length) :
          startIndex + pageSize;
        return length + ' Kayıttan ' + (startIndex + 1) + ' - ' + endIndex + ' arası ' ;
      };
  }

  ngOnInit() {

    this.loadEmployee();

    this.employeeTitleList.push(...this.lookupService.localListByLookupCode('TITLE').sort((a, b) =>
        a.description.toLowerCase().localeCompare(b.description.toLowerCase(), 'tr')
    ));
    
    // Sadece parent departmanları getir (parentLookup null olanlar)
    const allDepartments = this.lookupService.localListByLookupCode('DEPARTMENT');
    const parentDepartments = allDepartments.filter(dept => dept.parentLookup || dept.parentLookup !== null);
    this.departmentList.push(...parentDepartments.sort((a, b) =>
        a.lookupValue.toLowerCase().localeCompare(b.lookupValue.toLowerCase(), 'tr')
    ));
    
    this.genderList.push(...this.lookupService.localListByLookupCode(AppConstants.GENDER_LOOKUP_CODE).sort((a, b) =>
        a.description.toLowerCase().localeCompare(b.description.toLowerCase(), 'tr')
    ));
  }

  loadEmployee() {

    this.tableData = [];
    this.employeeService.getEmployeeByActive(this.employeeSearchRequest).subscribe(result => {
        this.allEmployeeData = result.responseData.items;
        this.allEmployeeData.forEach(element => {
          this.tableData = [...this.tableData, {...element, absenceDeservedList: new MatTableDataSource(element.absenceDeservedList)}];
        });
        this.dataSource = new MatTableDataSource(this.tableData);

        this.paginator.length = result.totalCount;
        this.paginator.pageIndex = this.employeeSearchRequest.pageNumber;
        this.paginator.pageSize = this.employeeSearchRequest.size;
        this.paginator._intl = this.paginatorIntl;
    });
  }

  toggleRow(element: any) {
    element.absenceDeservedList.data && (element.absenceDeservedList as MatTableDataSource<AbsenceDeserved>).data.length ?
        (this.expandedElement = this.expandedElement === element ? null : element) : null;
    this.cd.detectChanges();
    this.innerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<AbsenceDeserved>).sort = this.innerSort.toArray()[index]);
  }

    /**
     * filtrede turkce karaktere uygun olarak kucuk karakterlere donusturduk. Ayni sekilde filterpredicate te de
     * eldeki veriyi turkceye uygun kucuk harfe donusturup filtrelememiz lazim. aksi taktirde karakter sorunundan dolayi
     * arama dogru olmuyor.
     * Ornek:
     * tabloda RIDVAN diye bir veri olsun
     * eger arama cubuguna rıd yazarsak RIDVAN ı bulamaz
     * cunku I harfini kucuk i olarak algılıyor.
     * @param {Event} event
     */
  applyFilter(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = this.utilsService.toTurkishLowerCase(this.filterValue.trim());
  }

  openCreateModal() {
    this.dataSource.filter = null;
    const dialogRef = this.dialog.open(EmployeeAddComponent, {
      width: '800px',
      height: 'auto',
      data: {}
     });

    dialogRef.afterClosed().subscribe(result => {
        if (result) {
            this.dataSource.data.push(result.data);
            this.dataSource._updateChangeSubscription();
            // this.employeeListTable.renderRows();
        }
        if (this.filterValue != null) {
            this.dataSource.filter = this.utilsService.toTurkishLowerCase(this.filterValue.trim());
        }
    });
  }

  openUpdateModal(event,employee){
    event.stopPropagation();
    this.selectedEmployee = employee;

    const dialogRef = this.dialog.open(EmployeeAddComponent, {
      width: '800px',
      height: 'auto',
      data: employee
    });
    // this.dataSource.filter = null;
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
          const employeeIndex = this.allEmployeeData.findIndex(emp => emp.id === result.data.id);
          this.dataSource.data.splice(employeeIndex, 1, result.data);
          this.dataSource._updateChangeSubscription();
      }
      if (this.filterValue != null) {
          this.dataSource.filter = this.utilsService.toTurkishLowerCase(this.filterValue.trim());
      }
    });
  }

  openDeleteModal(event,employee) {
    event.stopPropagation();
    this.dataSource.filter = null;
    this.selectedEmployee = employee;

    const dialogRef = this.dialog.open(EmployeeDeleteComponent, {
      width: '300px',
      data: employee
    });

    dialogRef.afterClosed().subscribe(result => {
        if (result) {
            // tabloda ilgili satiri bul ve sil
            const deletedElementIndex = this.dataSource.data.findIndex(emp => emp.id === result.data.id);
            this.dataSource.data.splice(deletedElementIndex, 1);
            this.dataSource._updateChangeSubscription();
        }
        if (this.filterValue != null) {
            this.dataSource.filter = this.utilsService.toTurkishLowerCase(this.filterValue.trim());
        }
    });
  }

  filterGrid() {
      this.employeeSearchRequest.departmentId = this.selectedDepartment.id;
      this.employeeSearchRequest.titleId = this.selectedTitle.id;
      this.employeeSearchRequest.name = this.filterName;
      this.employeeSearchRequest.surname = this.filterSurname;
      this.employeeSearchRequest.birthDateMin = this.startDateFilterValue1.value ;
      this.employeeSearchRequest.birthDateMax = this.endDateFilterValue1.value ;
      this.employeeSearchRequest.gender = this.selectedGender.lookupValue ;
      this.employeeSearchRequest.active = this.activeFilterValue ? 1 : 0 ;
      this.employeeSearchRequest.isNew = this.isNewFilterValue ? 1 : null ;
      this.loadEmployee();
  }

  clearfilterGrid() {
      this.selectedTitle = this.employeeTitleList[0];
      this.selectedDepartment = this.departmentList[0];
      this.filterName = '';
      this.filterSurname = '';
      this.selectedGender = this.genderList[0];
      this.startDateFilterValue1.setValue(null);
      this.endDateFilterValue1.setValue(null);
      this.filterGrid();
  }

  prepareReportRequest() {
      console.log('selected department = ' + JSON.stringify(this.selectedDepartment) + ' ' + JSON.stringify(this.selectedTitle));
      this.employeeReportRequest.birthDateMin = this.startDateFilterValue1.value ;
      this.employeeReportRequest.birthDateMax = this.endDateFilterValue1.value ;
      this.employeeReportRequest.gender = this.selectedGender.lookupValue ;
      
      if (this.selectedDepartment.id) {
          console.log('request department');
          this.employeeReportRequest.departmentId = this.selectedDepartment.id;
      } else {
          this.employeeReportRequest.departmentId = null;
      }
      this.employeeReportRequest.name = this.filterName;
      this.employeeReportRequest.surname = this.filterSurname;

      if (this.selectedTitle) {
          this.employeeReportRequest.titleId = this.selectedTitle.id;
      } else {
          this.employeeReportRequest.titleId = null;
      }

  }

  exportArray() {
      this.prepareReportRequest();
      this.employeeService.getEmployeeReport(this.employeeReportRequest).subscribe(reportResult => {
          const excelData = this.reportService.convertEmployeeReportResponseToSheetDataWithName(reportResult.responseData.item);
          this.reportService.exportAsExcelFile(excelData, reportResult.responseData.item.workBookName);
      });
  }

    employeeListEvent(pageEvent: PageEvent) {
        this.employeeSearchRequest.size = pageEvent.pageSize;
        this.employeeSearchRequest.pageNumber = pageEvent.pageIndex;
        this.loadEmployee();
    }

    employeeSortEvent($event) {
      const sortId = $event.active ;
      const sortDirection =  $event.direction ;
      this.employeeSearchRequest.sortColumn = sortId ;
      this.employeeSearchRequest.sortDirection = sortDirection === 'asc' ? 1 : 0 ;
      this.loadEmployee();
    }

}

export interface AbsenceDeserved {
  id: number;
  employeeId: number;
  absenceType: number;
  absenceTypeDesc: string;
  unitOfInterval: string;
  deservedAmount: number;
  transferAmount: number;
  remainingAmount: number;
  startDate: string;
  endDate: string;
  totalUsedAbsenceAmount: number;
}

export interface ExportElement {
  Adı_Soyadı: string;
  Telefon: string;
  Email: string;
  Departman: string;
  Ünvan: string;
  İzin_Türü?: string;
  Hakediş_Tarihi: string;
  Hakediş: string;
  Devreden: string;
  Kullanılan: string;
  Kalan: string;
  İzin_Türü1: string;
  Hakediş_Tarihi1: string;
  Hakediş1: string;
  Devreden1: string;
  Kullanılan1: string;
  Kalan1: string;
}
